import { Box } from '@material-ui/core';
import { Text } from 'component/customize_style_component/styled_title';
import themes from 'styles/themes';

export interface IFieldItem {
    label: string;
    content: string;
    opacity?: number;
    labelClassName?: string;
    contentClassName?: string;
}

function InfoFieldItem({ label, content, opacity, labelClassName, contentClassName }: IFieldItem) {
    return (
        <Box borderBottom={`1px solid ${themes.palette.grey['500']}`}>
            <Text size={14} weight={'bold'} color={themes.palette.primary.main} className={labelClassName ?? ''}>
                {label}
            </Text>
            <Box minHeight={32}>
                <Text
                    size={16}
                    weight={400}
                    opacity={opacity}
                    padding={'6px 0'}
                    className={contentClassName ?? ''}
                    color={themes.palette.primary.main}
                >
                    {content}
                </Text>
            </Box>
        </Box>
    );
}

export default InfoFieldItem;
